export default __webpack_public_path__ + "static/media/dogify.0fc90cd1.png";